//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { shallowEqual, useSelector } from 'react-redux'



//  ----------------------------------------------------------------------------
//  Selectors
//  ----------------------------------------------------------------------------

//  -- Examples data ------------------
const selectore = (state) => state.oneway_bingo;
const teachersBingoSelector = (state) => state.teachers_bingo;
const learningModuleCountSelector = (state) => state.learningModuleCount;
//  -- Examples array selector --------



export const useOneWayBingo = () =>{
    const selectedData = useSelector(selectore, shallowEqual)
    return selectedData;
}

export const useTeachersBingo = () => {
    const selectedData = useSelector(teachersBingoSelector, shallowEqual)
    return selectedData;
}

export const useLearningModuleCount = () => {
    const selectedData = useSelector(learningModuleCountSelector, shallowEqual)
    return selectedData;
}